import React, { useState } from "react";
import { createPortal } from 'react-dom';
import { filter } from 'rxjs/operators';
import { useSubscribe } from '../../hooks';
import { error$ } from '../../observables/error';
import { FailureType, LocalFileSystemID } from '../../shared/types';
import { Button } from '../../ui/components';
import styles from './Error.less';
export default function Error() {
    const [errors, setErrors] = useState([]);
    const [current, setCurrent] = useState(0);
    const [icon, setIcon] = useState('warning');
    useSubscribe(() => error$.pipe(filter(() => !document.hidden)).subscribe(error => {
        process.env.NODE_ENV == 'development' && console.error(error);
        if (error.type == FailureType.RemoteError) {
            setErrors(errors => [...errors, { id: error.id, message: error.message, type: error.type }]);
        }
        else if (error.type == FailureType.APIError) {
            setErrors(errors => [...errors, { origin: error.method, message: error.message, type: error.type }]);
        }
        else if (error.type == FailureType.Warning || error.type == FailureType.Info) {
            setErrors(errors => [...errors, { message: error.message, html: true, type: error.type }]);
            if (error.type == FailureType.Info) {
                setIcon('info');
            }
        }
    }));
    return React.createElement(React.Fragment, null, errors.length > 0 && createPortal(React.createElement("div", { className: styles.root },
        React.createElement("button", { className: "close", onClick: () => setErrors([]) }, "\u2715"),
        React.createElement("i", { className: "icon", "data-type": errors[current].type }, icon),
        React.createElement("div", null,
            errors[current].id && errors[current].id != LocalFileSystemID &&
                React.createElement("em", null, errors[current].id),
            errors[current].html === true ?
                React.createElement("div", { className: "message", dangerouslySetInnerHTML: { __html: errors[current].message } }) :
                errors[current].message,
            errors[current].origin &&
                React.createElement("p", null,
                    "Origin: ",
                    errors[current].origin)),
        errors.length > 1 &&
            React.createElement("footer", null,
                React.createElement(Button, { onClick: () => setCurrent(Math.max(current - 1, 0)), disabled: current <= 0 }, "Previous"),
                current + 1,
                "/",
                errors.length,
                React.createElement(Button, { onClick: () => setCurrent(Math.min(current + 1, errors.length - 1)), disabled: current >= errors.length - 1 }, "Next"))), document.body));
}
